import { Component } from '@angular/core';
import { FpDocumentPrintingBase } from '../../fp-document-printing';

@Component({
  selector: 'fp-appointment-print-modal',
  styleUrls: ['../fp-appointment-results.component.less'],
  templateUrl: './fp-appointment-print-content.component.html',
})
export class FPAppointmentPrintContentComponent implements FpDocumentPrintingBase {
  data: any = [];
}
